export const classes = {
  wrapper:
    'flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 cursor-pointer hover:bg-black/5',
  label: 'select-none text-sm font-bold text-taupe-3',
  arrowIcon: 'text-base text-taupe-2',
};
